// Single source of truth for "can this product be added to an order".
// Mirrors the backend ProductRepository::isProductOrderable rule so the Order /
// SELECT buttons and the add-by-design-number API all agree:
//   orderable  = active AND (immediate qty > 0 OR future PO OR prebook active)
//   disabled   = inactive OR (immediate 0 AND no future PO AND no prebook)
// Future PO is already inside product_date_quantities, so any non-zero row covers
// both immediate and PO; prebook and the active/status gate are added on top.
export default {
  methods: {
    productHasAvailableQty(product) {
      return (product?.product_date_quantities || []).some((item) => {
        const q = String(item?.quantities ?? '')
        return q.includes(',')
          ? q.split(',').some((n) => Number(n) > 0)
          : Number(q) > 0
      })
    },

    productPrebookActive(product) {
      return !!(product?.is_prebooked && product?.prebook_date)
    },

    // ProductResource emits `is_active`; DigitalCatalogProductResource emits `status`.
    // Absent flag → treat as active (don't disable on missing data).
    productIsActive(product) {
      const flag = product?.is_active ?? product?.status
      return flag === undefined || flag === null ? true : !!Number(flag)
    },

    canOrderProduct(product) {
      if (!product || !this.productIsActive(product)) return false
      return this.productHasAvailableQty(product) || this.productPrebookActive(product)
    }
  }
}
